import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/navbar';
import Hero from './components/Hero';
import AboutUs from './components/Aboutus'; 
import Products from './components/Products';
import Testimonials from './components/Testimonials';
import Footer from './components/footer';
import Product1 from './components/Product1'; // Import your product components
import Product2 from './components/Product2';
import Product3 from './components/Product3';
import Product4 from './components/Product4';
import Product5 from './components/Product5';
import Product6 from './components/Product6';
import Product7 from './components/Product7';
import Product8 from './components/Product8';


function App() {
  return (
    <Router>
      <div className="font-sans">
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <section id="home">
                <Hero />
              </section>
              <section id="products">
                <Products />
              </section>
              <section id="about-us">
                <AboutUs />
              </section>
              <section id="testimonials">
                <Testimonials />
              </section>
              <section id="contact">
                <Footer />
              </section>
            </>
          } />
          <Route path="/product1" element={<Product1 />} />
          <Route path="/product2" element={<Product2 />} />
          <Route path="/product3" element={<Product3 />} />
          <Route path="/product4" element={<Product4 />} />
          <Route path="/product5" element={<Product5 />} />
          <Route path="/product6" element={<Product6 />} />
          <Route path="/product7" element={<Product7 />} />
          <Route path="/product8" element={<Product8 />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
